import { render, staticRenderFns } from "./NavbarSelection.vue?vue&type=template&id=641f8dbb&scoped=true&"
import script from "./NavbarSelection.vue?vue&type=script&lang=js&"
export * from "./NavbarSelection.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSelection.vue?vue&type=style&index=0&id=641f8dbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f8dbb",
  null
  
)

export default component.exports